import Vue from 'vue'
import Vuetify, {
  VTextField,
  VTextarea,
  VAutocomplete,
  VCheckbox,
  VSelect,
  VCombobox,
  Touch,
  VDatePicker,
  VSheet,
  VVirtualScroll

} from 'vuetify/lib' // Added sigle modules to correct vuetify-form-base bug with selected components, still issues with touch
import theme from './theme';

Vue.use(Vuetify, {
  theme,
  components: {
    VTextField,
    VTextarea,
    VAutocomplete,
    VCheckbox,
    VSelect,
    VCombobox,
    VDatePicker,
    VSheet,
    VVirtualScroll
  },
  directives: {
    Touch
  }
})

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#4fc1d3',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
})
